<template>
  <div class="open-report">
    <div class="notification alert alert-success" v-if="this.$route.path != reportPath">
      <div class="row">
        <div class="col-sm-9">
          <i class="fa fa-info-circle"></i> You currently have {{ article }}
          <strong>{{ report.QuoteType.quoteName }}</strong> ({{ report.reference }}) in use <span v-if="report.address">for <strong>{{ report.address }}</strong></span>
        </div>
        <div class="col-sm-3 text-right">
          <router-link class="my-2 btn btn-success" :to="reportPath">
            <i class="fa fa-folder-open"></i> Open
          </router-link>
          <button class="my-2 btn btn-info" @click="close(report.uuid)">
            <i class="fa fa-window-close"></i> Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    CLOSE_REPORT
  } from '@/vuex/types'
  export default {
    name: 'OpenReport',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    computed: {
      article () {
        if (['a', 'e', 'i', 'o', 'u'].includes(this.report.QuoteType.quoteType.toLowerCase().charAt(0))) {
          return 'an'
        }
        return 'a'
      },
      reportPath () {
        return `/approvedQuotes/createReport/${this.report.uuid}`
      },
      report () {
        return {
          ...this.object
        }
      }
    },
    methods: {
      async close (openReportUuid) {
        await this.$store.dispatch(CLOSE_REPORT, openReportUuid)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/displays/OpenReport.vue